import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";

/* === Admin === */
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/AdminDashboard";
import AddProduct from "./admin/AddProduct";
import ProductsList from "./admin/Products";
import EditProduct from "./admin/EditProduct";
import OrdersList from "./admin/OrdersList";
import OrderDetails from "./admin/OrderDetails";
import AdminLogin from "./admin/AdminLogin";
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute";

/* === Public === */
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Shop from "./pages/Shop";
import AboutUss from "./pages/AboutUs";
import Contact from "./pages/Contact";
import ProductDetail from "./pages/ProductDetail";

const App = () => {
  const [user, loading] = useAuthState(auth);

  if (loading) return null;

  return (
    <Routes>
      {/* === Admin Login === */}
      <Route
        path="/admin-login"
        element={user ? <Navigate to="/admin" replace /> : <AdminLogin />}
      />

      {/* === Admin Routes (Protected) === */}
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="products" element={<ProductsList />} />
        <Route path="add-product" element={<AddProduct />} />
        <Route path="edit-product/:id" element={<EditProduct />} />
        <Route path="orders" element={<OrdersList />} />
        <Route path="orders/:id" element={<OrderDetails />} />
      </Route>

      {/* === Public Routes === */}
      <Route path="/" element={<Home />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/about" element={<AboutUss />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/product/:id" element={<ProductDetail />} />

      {/* === Fallback === */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
